import { render, staticRenderFns } from "./EVoucherIssuanceDetail.vue?vue&type=template&id=bb49a188&scoped=true&"
import script from "./EVoucherIssuanceDetail.vue?vue&type=script&lang=js&"
export * from "./EVoucherIssuanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./EVoucherIssuanceDetail.vue?vue&type=style&index=0&id=bb49a188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb49a188",
  null
  
)

export default component.exports